import CompaignFilterProvider from './CompaignFilterProvider';

export default CompaignFilterProvider;
